import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe that forces the display of a positive (+) or negative (-) sign for numbers.
 * Useful for displaying differentials, changes, or comparative values.
 *
 * @example
 * {{ 25 | forceSign }} // Output: +25
 * {{ -15 | forceSign }} // Output: -15
 * {{ 0 | forceSign }} // Output: +0
 * {{ rate | forceSign : true }} // Output: +25 (with sign)
 * {{ rate | forceSign : false }} // Output: 25 (without sign)
 * {{ rate | currency : 'USD' | forceSign : showSign }} // Conditional application
 */
@Pipe({ name: 'forceSign', standalone: true })
export class ForceSignPipe implements PipeTransform {
  transform(
    value: number | string | null | undefined,
    shouldApply = true
  ): string {
    if (value == null) return '';

    const stringValue = typeof value === 'string' ? value : String(value);

    if (!shouldApply) return stringValue;

    let numValue: number;
    if (typeof value === 'number') numValue = value;
    else {
      const cleanedString = stringValue.replace(/[^\d.-]/g, '');
      numValue = parseFloat(cleanedString);
    }

    if (isNaN(numValue)) return stringValue;

    return numValue >= 0 ? `+${stringValue}` : stringValue;
  }
}
